import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { images } from '../../data/content';
export function About() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="about-title" data-id="element-70" data-mp="oqci2axj4eg1">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-71" data-mp="12pvnux2vbdp6">
        <div className="relative mx-auto w-full max-w-md" data-id="element-72" data-mp="yqmtbq007bsk">
          <img src={images.rachel} alt="Rachel Bennett, creator of the Critical Care Nursing Blueprint" className="aspect-square w-full rounded-3xl object-cover" data-id="element-73" data-mp="azhdvbxz6lis" />
          <div className="absolute -bottom-4 left-4 right-4 rounded-2xl bg-navy-950 px-5 py-3 text-center sm:left-8 sm:right-8" data-id="element-74" data-mp="jskolch8kk9q">
            <p className="font-black text-white" data-id="element-75" data-mp="f0j5b6lnhta7">Rachel Bennett</p>
            <p className="text-xs font-bold uppercase tracking-wider text-brand" data-id="element-76" data-mp="3ngmbf7x479wf">Creator of the Blueprint™</p>
          </div>
        </div>

        <div className="pt-4 lg:pt-0" data-id="element-77" data-mp="3jf137zvizjsk">
          <p className="text-sm font-extrabold uppercase tracking-wider text-brand-dark" data-id="element-78" data-mp="3398fg6fpxx1x">About the creator</p>
          <h2 id="about-title" className="mt-3 text-[28px] font-black leading-[1.1] tracking-tight text-ink text-balance sm:text-4xl" data-id="element-79" data-mp="3881uw4ekfy4q">
            Hi, I’m Rachel Bennett
          </h2>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-muted sm:text-[17px]" data-id="element-80" data-mp="3hyed3pywrf7p">
            <p className="font-semibold text-ink" data-id="element-81" data-mp="2kb5wa89uquc1">
              I created the Critical Care Nursing Blueprint™ around a simple educational idea: complex information
              becomes easier to navigate when it is organized into a clear, consistent structure.
            </p>
            <p data-id="element-82" data-mp="2z7dfp6dfrrq9">
              Critical care nursing involves a wide range of subjects, including hemodynamic monitoring, respiratory
              assessment, neurological evaluation, laboratory concepts, and clinical reasoning. When these subjects are
              spread across different textbooks, notes, and reference materials, reviewing them can become
              unnecessarily complicated.
            </p>
            <p data-id="element-83" data-mp="25m937zpycub0">
              That’s why I brought these topics together in one digital collection — six educational volumes, visual
              reference tables, practical worksheets, simulated clinical cases, and five complementary resources.
            </p>
            <p data-id="element-84" data-mp="2fhsyql0ltqz8">
              My intention isn’t to replace your clinical training or tell you that a digital resource can solve every
              challenge in critical care. It’s to give you a structured educational reference you can return to as you
              continue learning.
            </p>
            <p data-id="element-85" data-mp="20o7ilacvomxf">I hope the Critical Care Nursing Blueprint™ becomes a useful part of your professional study routine.</p>
          </div>
          <p className="mt-6 text-2xl font-black italic text-ink" data-id="element-86" data-mp="185ac6kns7owz">— Rachel Bennett</p>

          <div className="[&>div]:mx-0" data-id="element-87" data-mp="145085djjv8kr">
            <SectionCTA label="Start studying with Rachel’s Blueprint™" data-id="element-88" data-mp="143yud1b5g7zc" />
          </div>
        </div>
      </div>
    </section>;
}